import React from 'react';
import { Link } from 'react-router-dom';
import CategoryWrapper from '../Category/CategoryWrapper';
import CategoryHeader from '../Category/CategoryHeader';
import CategoryBody from '../Category/CategoryBody';
import ProductVertical from '../ProductVertical';
import { useSelector } from 'react-redux';
import { postsHighLightState$ } from '../../redux/selectors';

export default function HighlightPosts() {
  const highlightPosts = useSelector(postsHighLightState$);

  if (!highlightPosts || (highlightPosts && highlightPosts.length === 0)) {
    return null;
  }

  return (
    <CategoryWrapper>
      <CategoryHeader
        left={
          <>
            <img
              src="https://salt.tikicdn.com/ts/upload/c5/0e/02/23066556738e7f5df8b8fde5d0d1dfd6.png"
              alt="Icon"
              width="24"
            />&nbsp;Sản phẩm nổi bật
          </>
        }
        right={
          <Link to="/products" className="text-decoration-none">
            <div className="d-flex flex-direction-row align-items-center"><img
              src="https://salt.tikicdn.com/ts/upload/b2/14/5f/811ab1cf876d0e9d9a3de7c886ca7c59.png"
              alt="Icon"
              width="20"
              height="20"
            />&nbsp;XEM THÊM</div>
          </Link>
        }
      />
      <CategoryBody>
        {highlightPosts && highlightPosts.map(item => {
          const { _id, image, title, category, ...rest } = item;
          const images = (
            <img
              src={image}
              alt={title}
            />
          );
          return (
            <ProductVertical
              key={_id}
              path={`/${category}s/${_id}`}
              images={images}
              title={title}
              category={category}
              {...rest}
            />
          )
        })}
      </CategoryBody>
    </CategoryWrapper>
  );
}